import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaHome, FaArrowLeft, FaPaperPlane } from "react-icons/fa";
import "../style-new.css";

const DirectMessageList = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEligibleUsers = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const res = await fetch("/api/chat/eligible-users", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
        });

        if (!res.ok) {
          throw new Error(`Error fetching users: ${res.statusText}`);
        }

        const data = await res.json();
        console.log("Eligible users response:", data);
        setGroups(data);
      } catch (err) {
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    };

    fetchEligibleUsers();
  }, []);

  if (loading) {
    return (
      <div className="page-container center-content">
        Loading users...
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container center-content">
        Error: {error}
      </div>
    );
  }

  if (groups.length === 0) {
    return (
      <div className="page-container center-content">
        <div className="button-group">
          <button onClick={() => navigate('/')} className="btn btn-primary">
            <FaHome /> Home
          </button>
          <button onClick={() => navigate(-1)} className="btn btn-primary">
            <FaArrowLeft /> Back
          </button>
        </div>
        <p>You have no groups with members to message.</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="button-group">
        <button onClick={() => navigate('/')} className="btn btn-primary">
          <FaHome /> Home
        </button>
        <button onClick={() => navigate(-1)} className="btn btn-primary">
          <FaArrowLeft /> Back
        </button>
      </div>

      <div className="center-content">
        <h2>Direct Messages</h2>

        {groups.map((group) => (
          <div key={group.group_id} style={{ marginBottom: "25px" }}>
            <h3>{group.group_name}</h3>
            {group.members && group.members.length > 0 ? (
              <ul className="list-container">
                {group.members.map((user) => {
                  if (!user.user_id) {
                    console.warn("Skipping user with missing user_id:", user);
                    return null;
                  }
                  return (
                    <li key={user.user_id} style={{ marginBottom: "8px" }}>
                      <button
                        className="user-button"
                        onClick={() => navigate(`/chat/direct/${user.user_id}`)}
                      >
                        <FaPaperPlane style={{ marginRight: "8px" }} />
                        {user.name} {user.surname || ""}
                      </button>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <p>No eligible members in this group.</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DirectMessageList;
